<div id="mySidenav" class="sidenav">
  <ul class="left-sidenav-menu mm-show">
    <li class="dropdown notification-list">
      <a class="nav-link dropdown-toggle arrow-none " data-bs-toggle="dropdown" role="button"
        aria-haspopup="false" aria-expanded="false">
        <span class="text-ellipsis" style="padding-right: 13px;">{{currentlyLoggedInCompany.companyName}}</span>
        <i class="ms-auto fa-solid fa-bars"></i>
    </a>
    <div class="dropdown-menu loda-dropdown-menu dropdown-menu-end dropdown-lg pt-0 left-sidenav-dropdown-menu">
      <a (click)="onCompanySelectedToSwitchTo(currentlyLoggedInCompany.companyGuid, currentlyLoggedInCompany.companyName)"
        class="dropdown-item-text font-14 m-0 loda-dropdown-padding border-bottom d-flex align-items-center">
        <img [src]="lodaLogoImagePath" />
        <strong>{{currentlyLoggedInCompany.companyName}}</strong>
        <i class="ms-auto dripicons-checkmark"></i>
      </a>
      @for (companies of otherCompaniesThatCanBeSwitchedTo | groupBy: 'companyGuid'; track companies.key) {
        <a (click)="onCompanySelectedToSwitchTo(companies.value[0].companyGuid, companies.value[0].companyName)"
          class="dropdown-item-text font-14 m-0 loda-dropdown-padding border-bottom d-flex align-items-center">
          <img [src]="lodaLogoImagePath" />
          <strong>{{companies.value[0].companyName}}</strong>
          @if (currentCompanyGuid == companies.value[0].companyGuid) {
            <i class="ms-auto dripicons-checkmark"></i>
          }
        </a>
      }
    </div>
  </li>

  @for (item of menu; track item; let i = $index) {
    <li  [hidden]="(item.requireAdminPermission && !userHasAdminPermission) || (item.requireSuperAdminPermission && !userHasSuperAdminPermission) || (item.incompleteFeature && companyId != 2)"
      [ngClass]="{'dropdown dropend notification-list' : item.children && item.children.length}">
      <a [ngClass]="{'nav-link dropdown-toggle arrow-none' : item.children && item.children.length}"
        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span>{{ item.text }}</span>
        <i [ngClass]="item.icon"></i>
    </a>
    @if (item.children) {
      <ul class="dropdown-menu loda-dropdown-menu dropdown-menu-end dropend-menu">
        @for (ch of item.children; track ch; let ii = $index) {
<li class="dropdown dropend" [hidden]="ch.hide ||
          (ch.requireAdminPermission && !userHasAdminPermission) ||
          (ch.requireCallReportPermission && !allowMortgageCallReports) ||
          (ch.requireEnabledPricingPermission && !pricingEnabled) ||
          (ch.requireSuperAdminPermission && !userHasSuperAdminPermission)  ||
          (ch.requireEnabledOcrPermission && !ocrEnabled) ||
          (ch.requireEnabledLosPermission && !losEnabled) ||
          (ch.requireEnabledLoanBeamPermission && !loanBeamEnabled) ||
          (ch.requireEnabledChannelsPermission && !areThereEnabledChannels) ||
          (ch.requireEnabledDialerPermission && !dialerEnabled) ||
          (ch.requireEnabledCampaignsPermission && !campaignsEnabled)
          ">
            <a [ngClass]="{'active': ch.selected }" [routerLink]="getRouterLink(ch)">
              <span>{{ ch.text }}</span>
              @if (ch.icon) {
                <i [ngClass]="ch.icon"></i>
              }
          </a>
          @if (ch.children) {
            <ul class="dropdown-menu loda-dropdown-menu dropdown-menu-end dropend-menu">
              @for (sub of ch.children; track sub; let ii = $index) {
                <li class="dropdown dropend"
            [hidden]="(sub.requireAdminPermission && !userHasAdminPermission) ||
              (sub.requireEnabledBranchesPermission && !branchesEnabled) ||
              (sub.requireEnabledPricingPermission && !pricingEnabled) ||
              (sub.requireExternalCompanyEnabled && !externalCompanyEnabled) ||
              (sub.requireEnabledOcrPermission && !ocrEnabled) ||
              (sub.requireEnabledChannelsPermission && !areThereEnabledChannels) ||
              (sub.requireEnabledDialerPermission && !dialerEnabled) ||
              (sub.requireEnabledCampaignsPermission && !campaignsEnabled) ||
              (sub.requirePipelineMetricsPermission && !pipelineMetricsEnabled) ||
              (sub.requirePipelineWaterfallPermission && !pipelineWaterfallEnabled) ||
              (ch.incompleteFeature && companyId != 2)
              ">
                  <a [ngClass]="{'active': sub.selected }" [routerLink]="getRouterLink(sub)">
                    <span>{{ sub.text }}</span>
                    @if (sub.icon) {
                      <i [ngClass]="sub.icon"></i>
                    }
                </a>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
}
</li>
}
</ul>
</div>
